import React from 'react'

export const ElementOrg = (key, name, onChange) => {
  switch (key) {

    case "GUANAJUATO":
      // Guanajuato
      return(
        <select className="form-select"  name={name} id={`${name}Id`} onChange={onChange}>
          <option value="" defaultValue>SELECCIONA</option>
          <option value="00001">APASEO EL ALTO OFICINA CENTRAL</option>         {/*Apaseo el Alto*/}
          <option value="00006">APASEO EL ALTO OFICINA ALAMEDA </option>
          <option value="00002">SAN JOSE AGUA AZUL</option>
          <option value="00003">SAN BARTOLOME AGUA CALIENTE</option>
          <option value="00004">SAN PEDRO TENANGO</option>
          <option value="00005">CELAYA</option>
          
          <option value="00008">SAN JOSE ITURBIDE</option>
          <option value="00010">LA CUEVITA</option>
          <option value="00011">OJO DE AGUA DE LA TRINIDAD</option>
          <option value="00012">SAN ANTONIO CALICHAR</option>
          <option value="00013">SAN JUAN DEL LLANITO</option>
          <option value="00016">EL SALITRE</option>
          <option value="00017">DOCTOR MORA</option>
          <option value="00018">VICTORIA</option>
          <option value="00019">TIERRA BLANCA</option>
          <option value="00020">SANTA CATARINA</option>
          <option value="00021">ATARJEA</option>
          <option value="00023">SANTA CRUZ DE GAMBOA</option>
          <option value="00026">APASEO EL GRANDE</option>
          <option value="00030">LA CRUZ</option>
          <option value="00058">SAN NICOLAS DE PARRA</option> 
        </select>
      )
      
    case "QUERÉTARO":
      //Queretaro
      return (
        <select className="form-select" name={name} id={`${name}Id`} onChange={onChange}>
          <option value="" defaultValue>SELECCIONA</option>
          <option value="00007">SAN PEDRITO PEÑUELAS</option>   {/*Queretaro*/}
          <option value="00009">LOS ANGELES</option>            {/*Queretaro*/}
          <option value="00015">CIMATARIO</option>             {/*Queretaro*/}
          <option value="00022">LAS AMERICAS</option>          {/*Queretaro*/}
          <option value="00024">CERRITO COLORADO</option>      {/*Queretaro*/}
          <option value="00025">TEQUISQUIAPAN</option>         {/*Queretaro*/}
          <option value="00028">SAN JUAN DEL RIO</option>     {/*Queretaro*/}
          <option value="00029">LA CAÑADA</option>             {/*Queretaro*/}
          <option value="00049">MERCADO ESCOBEDO</option>      {/*Queretaro (ventanilla)*/}
          <option value="00051">LOMAS DE CASA BLANCA</option>  {/*Queretaro*/}
        </select>
      )

    case "HIDALGO": 
    //Hidalgo
      return(
        <select className="form-select" name={name} id={`${name}Id`} onChange={onChange}>
          <option value="" defaultValue>SELECCIONA</option>
          <option value="00027">HUICHAPAN</option>             {/*Hidalgo*/}
          <option value="00031">NOPALA</option>                {/*Hidalgo*/}
          <option value="00032">TECOZAUTLA</option>            {/*Hidalgo*/}
          <option value="00040">CHAPANTONGO</option>           {/*Hidalgo*/}
          <option value="00041">IXMIQUILPAN</option>           {/*Hidalgo (ventanilla)*/}
          <option value="00043">TULA DE ALLENDE</option>       {/*Hidalgo*/}
          <option value="00044">TEPEJI DEL RIO</option>        {/*Hidalgo*/}
          <option value="00054">MIXQUIAHUALA</option>          {/*Hidalgo (ventanilla)*/}
        </select>
      )
  
    case "EDO. DE MÉXICO":
      return(
        <select className="form-select" name={name} id={`${name}Id`} onChange={onChange}>
          <option value="" defaultValue>SELECCIONA</option>
          <option value="00033">SAN BARTOLO MORELOS</option>   {/*Edo. de México*/}
          <option value="00034">SAN JOSE DEL RINCON</option>   {/*Edo. de México*/}
          <option value="00035">TEMASCALTEPEC</option>        {/*Edo. de México*/}
          <option value="00036">VILLA DE ALLENDE</option>      {/*Edo. de México*/}
          <option value="00037">IXTAPAN DEL ORO</option>       {/*Edo. de México*/}
          <option value="00038">DONATO GUERRA</option>        {/*Edo. de México*/}
          <option value="00039">VALLE DE BRAVO</option>        {/*Edo. de México*/}
          <option value="00053">VILLA VICTORIA</option>        {/*Edo. de México*/}
          <option value="00055">JIQUIPILCO</option>            {/*Edo. de México (ventanilla)*/}
          <option value="00056">AMANALCO</option>              {/*Edo. de México*/}
        </select>
      )

      case "MORELOS": 
        return(
          <select className="form-select" name={name} id={`${name}Id`} onChange={onChange}>
            <option value="" defaultValue>SELECCIONA</option>
            <option value="00042">TEZONTEPEC</option>            {/*Morelos (ventanilla)*/}
            <option value="00045">TEMOAC</option>                {/*Morelos*/}
            <option value="00046">OCUITUCO</option>              {/*Morelos*/}
            <option value="00047">TLALNEPANTLA</option>          {/*Morelos*/}
            <option value="00052">CUERNAVACA</option>            {/*Morelos (ventanilla)*/}
            <option value="00057">CUAUTLA</option>               {/*Morelos*/}
          </select>
        )

    default:
      return (
        <select className="form-select" name={name} id={`${name}Id`} onChange={onChange}>
          <option value="" defaultValue>Select one</option>
        </select>
      )
      
  }
}
